import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication.service';
import { SessionService } from '../service/session.service';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(private auth: AuthenticationService, private session: SessionService, private router: Router) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const token = this.session.getToken();
    if (!token) {
      return this.router.navigate(['/unauthorized']).then(() => false);
    }
    if (this.session.user) {
      return true;
    } else {
      return this.auth.login(token).pipe(map(() => true));
    }
  }
}
